import { render } from "./CognitiveTests.vue?vue&type=template&id=7a8a4f49"
import script from "./CognitiveTests.vue?vue&type=script&lang=js"
export * from "./CognitiveTests.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__